import React, { useContext, useState } from 'react';
import DocumentImage from './DocumentImage';
import { GlobalContext } from '../../../../App';
import ConfirmationDialogOnlyOk from '../dialogs/ConfirmationDialogOnlyOk';
import CustomDialog from '../dialogs/customDialog';
import { Typography } from '@mui/material';

const PageDocumentsGrave = ({ documents }) => {

  const { permission } = useContext(GlobalContext); // Get user permission from context
  const [open, setOpen] = useState(false);

  const hasPermission = (documentPermissions, userPermission) => {
    return userPermission === 0 || documentPermissions.includes(userPermission);
  };

  const gridStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    minWidth: '200px',
    maxWidth: '100%',
    direction: 'rtl',
  };



  return (
    <>
    <div style={gridStyle}>
      {documents.map((image, index) => {
        const isAllowed = hasPermission(image.permissions, permission); // Check if the user has permission

        return (
          <DocumentImage 
            key={index} 
            id={image.id}
            src={image.src} 
            fileName={image.fileName} 
            handleClick={isAllowed ? image.handleClick : () => setOpen(true)} // Use undefined instead of null to remove the onClick event
            />
        )       
      }
      )}
    </div>

        <CustomDialog open={open} content={'content'} 
        yes={'אישור'} onOk={true} 
        handleClose={() => setOpen(false)}
        onAnswer={() => setOpen(false)} fullWidth = {false} >
          <Typography>אין לך הרשאות מספיקות</Typography>
        </CustomDialog>
    </>
  );
};

export default PageDocumentsGrave;

